// tslint:disable-next-line:max-line-length
const emailRegex = new RegExp(/^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/);

export const isEmailValid = (text: string): boolean => {
  return emailRegex.test(text);
};


// WEBPACK FOOTER //
// ./src/helpers/email-helper.ts